import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, PlayCircle, CalendarClock, ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const SEEN_KEY = "cr_welcome_seen";

export default function WelcomePopup() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [cfg, setCfg] = useState(null);
  const [videoEnabled, setVideoEnabled] = useState(true);

  useEffect(() => {
    if (!user || user.role !== "student") return;
    if (sessionStorage.getItem(SEEN_KEY)) return;
    api.get("/home").then((r) => {
      const wp = r.data.welcome_popup || {};
      setVideoEnabled(r.data.video_section_enabled !== false);
      if (wp.enabled !== false) { setCfg(wp); setOpen(true); }
    }).catch(() => {});
  }, [user]);

  const close = () => { sessionStorage.setItem(SEEN_KEY, "1"); setOpen(false); };
  const go = (path) => { close(); nav(path); };
  if (!cfg) return null;

  const cards = [
    { icon: BookOpen, title: "Free Upwork Course", desc: "The full 7-phase roadmap to landing clients.", path: "/course", color: "from-teal/15 to-teal/5", testId: "welcome-card-course" },
    ...(videoEnabled ? [{ icon: PlayCircle, title: "Video Walkthrough", desc: "Upwork Strategy & Awareness — premium video.", path: "/video", color: "from-orange/15 to-orange/5", testId: "welcome-card-video" }] : []),
    { icon: CalendarClock, title: "1-on-1 Mentorship", desc: "Book a personal session with Coach Reyland.", path: "/mentorship", color: "from-brandgreen/15 to-brandgreen/5", testId: "welcome-card-mentorship" },
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-lg" data-testid="welcome-popup">
        <DialogHeader>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-teal bg-teal/10 px-3 py-1 rounded-full w-fit"><Sparkles className="w-3.5 h-3.5" /> Welcome</span>
          <DialogTitle className="font-heading text-2xl">{cfg.title}</DialogTitle>
          <p className="text-sm text-muted-foreground">{cfg.message}</p>
        </DialogHeader>
        <div className="space-y-3 mt-1">
          {cards.map((c) => (
            <button key={c.title} onClick={() => go(c.path)} data-testid={c.testId}
              className={`w-full text-left flex items-center gap-4 p-4 rounded-2xl border border-border bg-gradient-to-br ${c.color} hover:shadow-md hover:-translate-y-0.5 transition-all`}>
              <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center shadow-sm shrink-0"><c.icon className="w-5 h-5 text-teal" /></div>
              <div className="flex-1 min-w-0"><p className="font-heading font-semibold">{c.title}</p><p className="text-xs text-muted-foreground">{c.desc}</p></div>
              <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0" />
            </button>
          ))}
        </div>
        <button onClick={close} className="text-sm text-muted-foreground hover:text-foreground mt-1" data-testid="welcome-dismiss">Maybe later</button>
      </DialogContent>
    </Dialog>
  );
}
